export default __webpack_public_path__ + "static/media/Rampa Acesso.cc987944.svg";